import { createFileRoute } from "@tanstack/react-router";
import { ContactSettingsPage } from "./-pages/contactSettings/contactSettings.page";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/contacts/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ContactSettingsPage />;
}
